import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Translate from '../layout/Translate';
import moment from 'moment'
import Price from '../layout/Price'

export default class AccountTourPreview extends Component {

    rating (numrows) {
        var rows = [];
        for (var i=1; i < numrows+1; i++) {
            rows.push(<div className="rate__star"></div>);
        }
        return rows;
    }


    selectTour() {
        this.props.toursActions.selectTour(this.props.tour)
    }



    toggleFeedback() {
        this.props.userActions.toggleFeedback();
    }

    getNumEnding(iNumber, aEndings)
    {
        var sEnding, i;
        iNumber = iNumber % 100;
        if (iNumber>=11 && iNumber<=19) {
            sEnding=aEndings[2];
        }
        else {
            i = iNumber % 10;
            switch (i)
            {
                case (1): sEnding = aEndings[0]; break;
                case (2):
                case (3):
                case (4): sEnding = aEndings[1]; break;
                default: sEnding = aEndings[2];
            }
        }
        return sEnding;
    }

    render () {

        let endings = [<Translate slug="tour__day-1" />, <Translate slug="tour__day-2-4" />, <Translate slug="tour__day-5-0" />];

        moment.locale('ru');
        const { tour, order, departure } = this.props;
        if (departure) {
            departure.now_date = new Date();
            departure.now_moment = moment(departure.now_date.getTime());

            departure.start_date = new Date(departure.start_at * 1000);


            departure.end_date = new Date(departure.end_at * 1000);
            departure.start_moment = moment(departure.start_at * 1000);
            departure.end_moment = moment(departure.end_at * 1000);
            departure.formated_start_date = departure.start_moment.format('D MMMM YYYY');
            departure.formated_end_date = departure.end_moment.format('D MMMM YYYY');
            departure.month_diff = departure.start_moment.diff(departure.now_moment, 'months');
            departure.diff = departure.start_moment.diff(departure.now_moment);
            departure.end_diff = departure.end_moment.diff(departure.now_moment);
        }


        return (
            <div>

                <div className="tours__tour">

                {tour.id &&
                    <Link to={`/tours/` + (tour.id)} onClick={this.selectTour.bind(this)}>
                        <div className="tours__photo" style={{backgroundImage: 'url('+ ((tour.coverImages && tour.coverImages.previews)?tour.coverImages.previews.browsing1000:'') +')'}}></div>
                    </Link>
                }
                {order.status == 'new' &&
                    <div className="tours__status">
                        <Translate slug="order__status_not-paid" />
                    </div>
                }
                {order.status == 'accepted' &&
                    <div className="tours__status tours__status_paied">
                        <Translate slug="order__status_paid" />
                    </div>
                }

                {tour.id &&
                    <div className="tours__info">
                        <span className="tours__type"><span
                            className="tours__type_required">Discovery</span>nature</span>
                        <h2 className="tours__title"><Link to={`/tours/` + (tour.id)}
                                                           onClick={this.selectTour.bind(this)}>{tour.title}</Link></h2>

                        <div className="tours__summary">
                            <div className="tours__summary-info ">
                                <div className="rate-preview">
                                    <div className="rate-preview__label"><Translate slug="tour__complexity"/></div>
                                    {this.rating(5).map((point, i) =>
                                        <div key={i}
                                             className={"rate-preview__star " + (tour.complexity_rate > i ? 'rate-preview__star_active' : '')}></div>
                                    )}
                                </div>
                                <div className="rate-preview">
                                    <div className="rate-preview__label"><Translate slug="tour__service"/></div>
                                    {this.rating(3).map((point, i) =>
                                        <div key={i}
                                             className={"rate-preview__star " + (tour.service_rate > i ? 'rate-preview__star_active' : '')}></div>
                                    )}
                                </div>

                            </div>
                            <div className="tours__summary-info tours__summary-info_right"><span
                                className="tours__price">
                                <Price price={order.processing.total_price} currency={order.processing.currency} />
                            </span>
                            </div>
                            <div
                                className="tours__summary-info tours__summary-info_right">{(departure) ? departure.formated_start_date : ''}</div>
                            <div className="tours__summary-info tours__summary-info_right">{tour.days_count} <span
                                className="tours__uppercase-label">{this.getNumEnding(tour.days_count, endings)}</span>
                            </div>
                        </div>
                    </div>
                }

                {!tour.id &&
                    <div className="tours__info">
                        <h2><br/><br/><br/></h2>
                    </div>
                }
                <hr className="tours__line" />

                <div className="tours__order tours__info">

                    {departure && departure.diff > 0 &&
                        <div className="tours__calendar">
                            <Translate slug="order__countdown" />: <span
                            className="tours__label_white">{parseInt(departure.diff / (3600 * 24 * 1000))} {this.getNumEnding(parseInt(departure.diff / (3600 * 24 * 1000)), endings)}</span>
                        </div>
                    }
                    {departure && departure.diff < 0 && departure.end_diff > 0 &&
                        <div className="tours__calendar">
                            <Translate slug="order__countdown_start" />
                        </div>
                    }
                    {departure && departure.diff < 0 && departure.end_diff < 0 &&
                        <div className="tours__calendar">
                            <Translate slug="order__countdown_end" />
                        </div>
                    }
                    <div className="tours__count">
                        <Translate slug="order__tourist-count" />: <span className="tours__label_white">{order.count}</span>
                    </div>
                    <div className="tours__calculation calculation">

                        {!!parseFloat(order.processing.total_paid) && (order.processing.total_paid < order.processing.total_cost) &&
                        <div className="calculation__row">
                                <div className="calculation__cell calculation__label">
                                    <Translate slug="order__prepaid" />:
                                </div>
                            <div className="calculation__cell calculation__price">
                                <div className="tours__price">
                                    <Price price={order.processing.total_paid} currency={order.processing.currency} />
                                </div>
                            </div>
                        </div>
                        }

                        {order.processing.total_paid < order.processing.total_cost &&
                        <div className="calculation__row">
                            <div className="calculation__cell calculation__label">
                                <Translate slug="order__need-paid" /> <span
                                className="tours__label_white tours__label_normal">(до ? мая ????):</span>

                            </div>
                            <div className="calculation__cell calculation__price">
                                <div className="tours__price">
                                    <Price price={order.processing.total_cost} currency={order.processing.currency}/>
                                </div>
                            </div>
                        </div>
                        }

                    </div>
                </div>


                <div className=" tours__info">

                <button className="tours__button" onClick={this.toggleFeedback.bind(this)}><Translate slug="order__question" /></button>
                <Link to={"/order/" + order.id} className="tours__button"><Translate slug="order__edit" /></Link>

                {order.processing.total_paid < order.processing.total_cost &&
                    <Link to={"/order/" + order.id} className="tours__button_active tours__button tours__button_right tours__buy"><Translate slug="order__paid-button" /></Link>
                }
                </div>
                </div>

            </div>



        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/tours/AccountPreview.js